import classNames from "classnames";
import styles from "./JobList.module.scss";
import { list } from "../../common/jobList/jobList.js";
import { useState } from "react";
import { Link } from "react-router-dom";
import arrow from "../../Img/jobPage/arrow.png";

const JobList = ({
  isDarkMode,
  isSidebar,
  width,
}: {
  isDarkMode: boolean;
  isSidebar: boolean;
  width: number;
}) => {
  const [positionName, setPositionName] = useState("전체");

  const onClick = (e: any): void => {
    const target = e.target as HTMLElement;
    setPositionName(target.innerText.split(" ")[0]);

    return;
  };
  const isSelect = (position: string): boolean => {
    return positionName === position;
  };

  return (
    <div className={styles.container}>
      {/*768px~480px responsibility dropDown*/}
      {/* <div
        className={!isSidebar ? styles.dropDownMenu : styles.hide_dropDownMenu}
      >
        <div
          className={
            !isDarkMode ? styles.dropDownTitle : styles.dark_dropDownTitle
          }
          onClick={onDropDown}
        >
          {positionName === "전체"
            ? `전체 ${list.length}`
            : `${positionName} ${
                list.filter((data) => data.position === positionName).length
              }`}
          <img
            src={arrow}
            alt=""
            className={!dropDown ? styles.arrow : styles.activeArrow}
          />
        </div>
        {!isDarkMode && (
          <div
            className={
              !dropDown
                ? styles.inactivedropDownMenuList
                : styles.activedropDownMenuList
            }
          >
            <div
              className={classNames(
                isSelect("전체") ? styles.drop_active : styles.drop_inactive
              )}
            >
              <span onClick={onClick}>전체</span> <span>{list.length}</span>
            </div>
            <div
              className={classNames(
                isSelect("개발") ? styles.drop_active : styles.drop_inactive
              )}
            >
              <span onClick={onClick}>개발</span>
              <span>
                {list.filter((data) => data.position === "개발").length}
              </span>
            </div>
            <div
              className={classNames(
                isSelect("디자인") ? styles.drop_active : styles.drop_inactive
              )}
            >
              <span onClick={onClick}>디자인</span>
              <span>
                {list.filter((data) => data.position === "디자인").length}
              </span>
            </div>
            <div
              className={classNames(
                isSelect("경영지원") ? styles.drop_active : styles.drop_inactive
              )}
            >
              <span onClick={onClick}>경영지원</span>
              <span>
                {list.filter((data) => data.position === "경영지원").length}
              </span>
            </div>
            <div
              className={classNames(
                isSelect("사업/마케팅")
                  ? styles.drop_active
                  : styles.drop_inactive
              )}
            >
              <span onClick={onClick}>사업/마케팅</span>
              <span>
                {list.filter((data) => data.position === "사업/마케팅").length}
              </span>
            </div>
          </div>
        )}
        {isDarkMode && (
          <div
            className={
              !dropDown
                ? styles.dark_inactivedropDownMenuList
                : styles.dark_activedropDownMenuList
            }
          >
            <div
              className={classNames(
                isSelect("전체")
                  ? styles.drop_active
                  : styles.dark_drop_inactive
              )}
            >
              <span onClick={onClick}>전체</span> <span>{list.length}</span>
            </div>
            <div
              className={classNames(
                isSelect("개발")
                  ? styles.drop_active
                  : styles.dark_drop_inactive
              )}
            >
              <span onClick={onClick}>개발</span>
              <span>
                {list.filter((data) => data.position === "개발").length}
              </span>
            </div>
            <div
              className={classNames(
                isSelect("디자인")
                  ? styles.drop_active
                  : styles.dark_drop_inactive
              )}
            >
              <span onClick={onClick}>디자인</span>
              <span>
                {list.filter((data) => data.position === "디자인").length}
              </span>
            </div>
            <div
              className={classNames(
                isSelect("경영지원")
                  ? styles.drop_active
                  : styles.dark_drop_inactive
              )}
            >
              <span onClick={onClick}>경영지원</span>
              <span>
                {list.filter((data) => data.position === "경영지원").length}
              </span>
            </div>
            <div
              className={classNames(
                isSelect("사업/마케팅")
                  ? styles.drop_active
                  : styles.dark_drop_inactive
              )}
            >
              <span onClick={onClick}>사업/마케팅</span>
              <span>
                {list.filter((data) => data.position === "사업/마케팅").length}
              </span>
            </div>
          </div>
        )}
      </div> */}

      <ul className={styles.positionList}>
        {!isDarkMode ? (
          <>
            {" "}
            <li
              onClick={onClick}
              className={classNames(
                isSelect("전체")
                  ? styles.active_postion
                  : styles.inactive_postion,
                "label-kr-L"
              )}
            >
              전체 {list.length}
            </li>
            <li
              onClick={onClick}
              className={classNames(
                isSelect("개발")
                  ? styles.active_postion
                  : styles.inactive_postion,
                "label-kr-L"
              )}
            >
              개발 {list.filter((data) => data.position === "개발").length}
            </li>
            <li
              onClick={onClick}
              className={classNames(
                isSelect("디자인")
                  ? styles.active_postion
                  : styles.inactive_postion,
                "label-kr-L"
              )}
            >
              디자인 {list.filter((data) => data.position === "디자인").length}
            </li>
            <li
              onClick={onClick}
              className={classNames(
                isSelect("경영지원")
                  ? styles.active_postion
                  : styles.inactive_postion,
                "label-kr-L"
              )}
            >
              경영지원{" "}
              {list.filter((data) => data.position === "경영지원").length}
            </li>
            <li
              onClick={onClick}
              className={classNames(
                isSelect("사업/마케팅")
                  ? styles.active_postion
                  : styles.inactive_postion,
                "label-kr-L"
              )}
            >
              사업/마케팅{" "}
              {list.filter((data) => data.position === "사업/마케팅").length}
            </li>
          </>
        ) : (
          /*DarkMode*/
          <>
            <li
              onClick={onClick}
              className={classNames(
                isSelect("전체")
                  ? styles.dark_active_postion
                  : styles.dark_inactive_postion
              )}
            >
              전체 {list.length}
            </li>
            <li
              onClick={onClick}
              className={classNames(
                isSelect("개발")
                  ? styles.dark_active_postion
                  : styles.dark_inactive_postion
              )}
            >
              개발 {list.filter((data) => data.position === "개발").length}
            </li>
            <li
              onClick={onClick}
              className={classNames(
                isSelect("디자인")
                  ? styles.dark_active_postion
                  : styles.dark_inactive_postion
              )}
            >
              디자인 {list.filter((data) => data.position === "디자인").length}
            </li>
            <li
              onClick={onClick}
              className={classNames(
                isSelect("경영지원")
                  ? styles.dark_active_postion
                  : styles.dark_inactive_postion
              )}
            >
              경영지원{" "}
              {list.filter((data) => data.position === "경영지원").length}
            </li>
            <li
              onClick={onClick}
              className={classNames(
                isSelect("사업/마케팅")
                  ? styles.dark_active_postion
                  : styles.dark_inactive_postion
              )}
            >
              사업/마케팅{" "}
              {list.filter((data) => data.position === "사업/마케팅").length}
            </li>
          </>
        )}
      </ul>
      <div
        className={classNames(
          !isDarkMode ? styles.proceed : styles.dark_proceed,
          "label-kr-L"
        )}
      >
        <p>
          {positionName}{" "}
          {
            list.filter((data) =>
              positionName === "전체"
                ? data.position
                : data.position === positionName
            ).length
          }
        </p>
        <p>건의 채용이 진행 중 입니다.</p>
      </div>
      <ul
        className={classNames(
          !isDarkMode ? styles.job_container : styles.dark_job_container
        )}
      >
        {positionName === "전체" ? (
          <>
            {list.map((data) => (
              <Link to={`/position/${data.id}`} state={data} key={data.id}>
                <li className={styles.jobList} key={data.id}>
                  <div className={classNames(styles.type, "label-kr-M")}>
                    {data.type}
                  </div>
                  <div className={classNames(styles.duty, "title-kr-XL")}>
                    {data.team} {data.duty}
                  </div>
                  <div className={classNames(styles.explain, "body-kr-L")}>
                    {data.explain}
                  </div>
                  <ul className={styles.tag_container}>
                    {data.tag.map((list, idx) => (
                      <li
                        className={classNames(styles.tag, "label-kr-S")}
                        key={idx}
                      >
                        {list}
                      </li>
                    ))}
                  </ul>
                </li>
              </Link>
            ))}
          </>
        ) : (
          <>
            {list.map(
              (data) =>
                data.position === positionName && (
                  <Link to={`/position/${data.id}`} state={data} key={data.id}>
                    <li className={styles.jobList} key={data.id}>
                      <div className={classNames(styles.type, "label-kr-M")}>
                        {data.type}
                      </div>
                      <div className={classNames(styles.duty, "title-kr-XL")}>
                        {data.team} {data.duty}
                      </div>
                      <div className={classNames(styles.explain, "body-kr-L")}>
                        {data.explain}
                      </div>
                      <ul className={styles.tag_container}>
                        {data.tag.map((list, idx) => (
                          <li
                            className={classNames(styles.tag, "label-kr-S")}
                            key={idx}
                          >
                            {list}
                          </li>
                        ))}
                      </ul>
                    </li>
                  </Link>
                )
            )}
          </>
        )}
      </ul>
    </div>
  );
};

export default JobList;
